export default __webpack_public_path__ + "static/media/print_logo.f4770462.png";